import Label from "components/Label/Label";
import { FC, useState, useEffect } from "react";
import Input from "shared/Input/Input";
import useFetch from "hooks/useFetch";
import config from "config.json";
import { useNavigate } from "react-router-dom";

interface ModalProps {
    message: string;
    title: string;
    isModalOpen: boolean;
    handleModalClose: () => void;
    userData: User;
}

interface User {
    firstname: string;
    lastname: string;
    document: string;
    mail: string;
    phones: Phone[];
    fecha_nacimiento: string;
}
interface Phone {
    phone_number: string;
    active: boolean;
}

const modalStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

interface IbodyContrasenia {
    old_password: string;
    new_password: string;
}

const EditUserPasswordModal: FC<ModalProps> = ({ userData, isModalOpen, handleModalClose }) => {
    const [bodyContrasenia, setBodyContrasenia] = useState<IbodyContrasenia>({
        old_password: '',
        new_password: ''
    });

    const [newPassword, setNewPassword] = useState<string>('');
    const [confirmNewPassword, setConfirmNewPassword] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
    const navigate = useNavigate();

    const [realizarPeticion, setrealizarPeticion] = useState(false)

    const { data, error, isLoading, fetchData } = useFetch(
        'PUT',
        `${config.backend_url}/authe/password`,
        bodyContrasenia,
        { 'Content-Type': 'application/json', 'SetiaAuthorization': `${sessionStorage.getItem('user_token')}` }
    );
    
 

    useEffect(() => {
        if (data) {
            // Éxito: mostramos el modal de éxito
            setShowSuccessModal(true);
        } else if (error) {
            setErrorMessage("Error al cambiar la contraseña. Inténtalo nuevamente.");
        }
        setIsSubmitting(false);
    }, [data, error]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setErrorMessage(null);

        if (newPassword !== confirmNewPassword) {
            setErrorMessage("Las contraseñas no coinciden.");
            return;
        }

        if (newPassword.length < 6 || confirmNewPassword.length < 6){
            setErrorMessage("La nueva contraseña debe tener al menos 6 caracteres.");
            return;
        }

        setIsSubmitting(true);
        setBodyContrasenia({
            old_password: bodyContrasenia.old_password,
            new_password: newPassword
        });
        
        setrealizarPeticion(true)
    };

    useEffect(() => {
      if(realizarPeticion){
        fetchData();
      }
    }, [setrealizarPeticion,bodyContrasenia])
    


    const handleSuccessRedirect = () => {
        sessionStorage.clear(); // Limpiamos la sesión
        navigate("/login"); // Redireccionamos al login
    };

    if (!isModalOpen) {
        return null;
    }

    return (
        <>
            <div className="fixed z-40 inset-0 overflow-y-auto" id="my-modal">
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0 sm:h-screen sm:items-center sm:flex sm:w-50% " style={modalStyle}>
                    <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                        <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div className="inline-block align-bottom bg-white max-h-[80vh] rounded-lg px-4 pt-5 pb-4 text-left overflow-y-auto min-w-[50vw] max-w-4xl shadow-xl transform transition-all "
                        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <h2 className="text-2xl font-semibold mb-4 text-center">Editar contraseña del usuario</h2>

                        <form onSubmit={handleSubmit}>
                            <div className="flex justify-center">
                                <div className="flex-grow lg:flex lg:flex-wrap  md:mt-0  max-w-3xl space-y-6 ">
                                    <div className="lg:w-full lg:p-2 lg:mt-6">
                                        <Label>Contraseña actual</Label>
                                        <Input
                                            className="mt-1.5"
                                            placeholder="Contraseña actual"
                                            type="password"
                                            value={bodyContrasenia.old_password}
                                            onChange={(e) =>
                                                setBodyContrasenia({ ...bodyContrasenia, old_password: e.target.value })
                                            }
                                        />
                                    </div>
                                    <div className="lg:w-1/2 lg:p-2">
                                        <Label>Nueva contraseña</Label>
                                        <Input
                                            className="mt-1.5"
                                            placeholder="Nueva contraseña"
                                            type="password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                        />
                                    </div>
                                    <div className="lg:w-1/2 lg:p-2">
                                        <Label>Confirmar nueva contraseña</Label>
                                        <Input
                                            className="mt-1.5"
                                            placeholder="Confirmar nueva contraseña"
                                            type="password"
                                            value={confirmNewPassword}
                                            onChange={(e) => setConfirmNewPassword(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            {errorMessage && <p className="text-red-500 text-center">{errorMessage}</p>}
                            <div className="flex justify-center w-full mt-4">
                                <button
                                    type="button"
                                    className="bg-red-500 text-white px-4 py-2 rounded-full mr-4"
                                    onClick={()=>{setErrorMessage(null);handleModalClose()}}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="bg-blue-500 text-white px-4 py-2 rounded-full"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Guardando..." : "Guardar Cambios"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {showSuccessModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white rounded-lg p-6 text-center">
                        <h2 className="text-2xl font-semibold mb-4">¡Contraseña actualizada exitosamente!</h2>
                        <p className="mb-4">Serás redirigido al login para iniciar sesión nuevamente.</p>
                        <button
                            onClick={handleSuccessRedirect}
                            className="bg-blue-500 text-white px-4 py-2 rounded-full"
                        >
                            Ir al login
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default EditUserPasswordModal;
